import React from "react";
import Layout from "./Layout";
import aboutTeam from './assets/about_team.jpg';
import aboutCompliance from './assets/about_compliance.jpg';

export default function About() {
  return (
    <Layout>
      <h2 className="text-3xl md:text-4xl font-bold mb-6">
        About NextDME
      </h2>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="relative rounded-xl overflow-hidden shadow-lg">
          <img
            src={aboutTeam}
            alt="Team"
            className="w-full h-64 md:h-80 object-cover"
          />
        </div>

        <div className="relative rounded-xl overflow-hidden shadow-lg">
          <img
            src={aboutCompliance}
            alt="Compliance"
            className="w-full h-64 md:h-80 object-cover"
          />
        </div>
      </div>

      <p className="mt-6 text-gray-700">
        NextDME provides innovative software solutions for DME providers,
        streamlining claims, inventory, and patient management while ensuring full HIPAA compliance.
      </p>
    </Layout>
  );
}